import React from "react";
import styled from "styled-components";

import Fieldset from "./styled/fieldset";
import Legend from "./styled/legend";
import HeadingCell from "./styled/heading_cell";

import {EnhancedLlmRun} from "common/flowmaster/types/llm_run";
import TextCopier from "./actions/text_copier";

interface Props {
  llmRun: EnhancedLlmRun;
}

const InputRow = styled.tr`
  & th,
  & td {
    padding: 0.25em 1em;
  }
  & th:not(:last-child),
  & td:not(:last-child) {
    border-right: 1px solid #ddd;
  }
`;

const InputCell = styled.td`
  :not(:last-child) {
    border-right: 1px solid #ddd;
    padding-right: 1em;
  }
`;

export default function Inputs({llmRun}: Props) {
  return (
    <Fieldset>
      <Legend>Inputs</Legend>
      <table style={{tableLayout: "fixed", width: "100%"}}>
        <thead>
          <InputRow>
            <HeadingCell style={{width: "5em"}}>key</HeadingCell>
            <HeadingCell style={{width: "10em"}}>name</HeadingCell>
            <HeadingCell style={{width: "100%"}}>value</HeadingCell>
          </InputRow>
        </thead>
        <tbody>
          {Object.entries(llmRun.data.data_store.input).map(([key, item]) => {
            const inputId = parseInt(key, 10);
            const input = llmRun.inputs.find(input => input.id === inputId);
            return (
              <InputRow key={key}>
                <InputCell>{key}</InputCell>
                <InputCell>{input?.name}</InputCell>
                <InputCell>
                  <TextCopier
                    text={
                      typeof item === "object"
                        ? JSON.stringify(item, null, 2)
                        : item
                    }
                  />
                </InputCell>
              </InputRow>
            );
          })}
        </tbody>
      </table>
    </Fieldset>
  );
}
